import { ReactComponent as SearchIcon } from '../../../../../../../assets/icons/emptyPatientsIcons/searchIcon.svg';
import classNames from 'classnames';
import styles from './index.module.scss';

const EmptyEMRResults = ({ isEmpty }: { isEmpty?: boolean }) => {
  return isEmpty ? (
    <div className={classNames('font-semibold text-lg text-center', styles.emrLabel)}>
      Results will appear here
    </div>
  ) : (
    <div
      className={classNames(
        'text-center flex flex-col gap-4 items-center',
        styles.emrLabel,
      )}
    >
      <SearchIcon />
      <div className={'font-semibold text-3xl'}>No results found in EMR</div>
      <div className={'text-base w-3/5'}>
        There were no patients found that match the identifiers.
      </div>
    </div>
  );
};

export default EmptyEMRResults;
